import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getBatch() {
  try {
    const data = await axiosInstance({
      url: "/batch",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLoginToken()}`,
      },
    });

    return data?.data?.data;
  } catch (error: any) {
    throw new Error(error);
  }
}

const createBatch = async (formData: any) => {
  const data = await axiosInstance({
    url: "/batch",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateBatch = async (formData: any) => {
  const data = await axiosInstance({
    url: `/batch/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteBatch = async (formData: any) => {
  const data = await axiosInstance({
    url: `/batch/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useBatch() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.batch],
    queryFn: () => getBatch(),
  });
  return data;
}

export function useCreateBatch() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createBatch(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.batch]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateBatch() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateBatch(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.batch]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteBatch() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteBatch(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.batch]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
